import { gql } from '@apollo/client';

export const GET_FUTURE_PRODUCT_PRICES = gql(/* GraphQL */ `
    query GetFutureProductPrices($productId: String!) {
        getFutureProductPrices(productId: $productId) {
            id
            type
            price
            currency
            validFrom
            validTo
        }
    }
`);

export type FutureProductPriceRow = {
    __typename?: 'FutureProductPrice';
    id: string;
    type: string;
    price?: number | null;
    currency?: string | null;
    validFrom?: string | null;
    validTo?: string | null;
};

export type GetFutureProductPricesQuery = {
    getFutureProductPrices: FutureProductPriceRow[];
};
